import { OrdersResponse } from 'src/types/CataloguePage.types';
import { carmaCsrAuthClient } from './instance/carmaCsrAuthClient';

export const getOrdersIgnoreError = () =>
  carmaCsrAuthClient
    .get<OrdersResponse[]>('me/orders')
    .json()
    .catch((_error) => null);
